import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=6b221fc4&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.scss?vue&type=style&index=0&id=6b221fc4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b221fc4",
  null
  
)

export default component.exports